import Vue from 'vue';

import PxAvisoPlataformaFornecedor from './PxAvisoPlataformaFornecedor.vue';
import PxAvisoPlataformaFornecedorSimple from './PxAvisoPlataformaFornecedorSimple.vue';

Vue.component('PxAvisoPlataformaFornecedor', PxAvisoPlataformaFornecedor);
Vue.component('PxAvisoPlataformaFornecedorSimple', PxAvisoPlataformaFornecedorSimple);
